import RepositoryManager from '@ComponentsRoot/core/RepositoryManager';
import { InjectedPropsType } from '@ComponentsRoot/core/types/InjectedPropsType';
import moment from 'moment';

export default class DashboardController {
  repositoryManager: RepositoryManager;
  setIsError: any;
  constructor(viewProps: InjectedPropsType, setIsError: any) {
    this.repositoryManager = viewProps.outletContext!.repositoryManager;
    this.setIsError = setIsError;
  }

  setError = (error: any) => {
    this.setIsError(error);
  };

  toggleError = () => {
    this.setIsError(null);
  };

  getUncoverdTurns = async (
    props: InjectedPropsType,
    setUncoverTurns: any,
    setResolveTurns: any,
    setShowSpinner: any,
    setDataResults: any,
    since: number,
    until: number
  ) => {
    try {
      setShowSpinner('d-block');
      const res = await this.repositoryManager.getTurnsRepository().getUncoverdTurns(props.outletContext?.accessToken, since, until);
      if (res) {
        setShowSpinner('d-none');
        setUncoverTurns(res);
        setDataResults(res);
        setResolveTurns(null);
      }
    } catch (error) {
      setShowSpinner('d-none');
      this.setError(error);
    }
  };

  getResolveTurns = async (
    props: InjectedPropsType,
    setResolveTurns: any,
    setUncoverTurns: any,
    setShowSpinnerBtn: any,
    setDisabledBtn: any,
    setDataResults: any,
    since: number,
    until: number
  ) => {
    try {
      setShowSpinnerBtn('d-block');
      setDisabledBtn(true);
      const res = await this.repositoryManager.getTurnsRepository().getResolveTurns(props.outletContext?.accessToken, since, until);
      res.forEach((itm: any) => {
        if (itm.affectedTurns?.length) {
          itm.expanded = false;
        } else {
          itm.expanded = null;
        }
      });
      if (res) {
        setShowSpinnerBtn('d-none');
        setDisabledBtn(false);
        setUncoverTurns(null);
        setResolveTurns(res);
        setDataResults(res);
      }
    } catch (error) {
      setShowSpinnerBtn('d-none');
      setDisabledBtn(false);
      this.setError(error);
    }
  };

  assignTurnsDayByDay = async (
    props: InjectedPropsType,
    uncoverTurns: any[],
    setResolveTurns: any,
    setUncoverTurns: any,
    setDataResults: any,
    setProgress: any,
    setCurrentDayText: any,
    setDayErrors: any,
    setDisabledBtn: any,
    cancelSignal: { cancelled: boolean }
  ) => {
    const toUTCDateKey = (date: string | Date): string => {
      const d = new Date(date as any);
      return d.toISOString().slice(0, 10);
    };

    const getDayRange = (dateStr: string): { since: number; until: number } => {
      const d = new Date(dateStr + 'T00:00:00.000Z');
      const since = d.getTime();
      const until = since + 86399999;
      return { since, until };
    };

    const uniqueDays = [...new Set(uncoverTurns.map((t: any) => toUTCDateKey(t.startDateTime)))].sort() as string[];
    const total = uniqueDays.length;

    if (total === 0) return;

    setDisabledBtn(true);
    setDayErrors([]);
    setProgress({ current: 0, total });

    const allResolved: any[] = [];

    for (let i = 0; i < uniqueDays.length; i++) {
      if (cancelSignal.cancelled) break;

      const day = uniqueDays[i];
      const { since, until } = getDayRange(day);
      const displayDay = `${day.slice(8, 10)}/${day.slice(5, 7)}/${day.slice(0, 4)}`;

      setCurrentDayText(`Procesando ${displayDay}...`);

      try {
        const res = await this.repositoryManager.getTurnsRepository().getResolveTurns(props.outletContext?.accessToken, since, until);
        res.forEach((itm: any) => {
          itm.expanded = itm.affectedTurns?.length ? false : null;
        });
        allResolved.push(...res);
        setResolveTurns([...allResolved]);
        setUncoverTurns(null);
        setDataResults([...allResolved]);
      } catch (error: any) {
        const status = error?.response?.status;
        if (status === 401) {
          setDayErrors((prev: any[]) => [
            ...prev,
            { day: displayDay, message: 'Tu sesión ha caducado. Por favor, vuelve a iniciar sesión.' },
          ]);
          break;
        }
        const msg =
          status === 500
            ? `Error interno del servidor para el día ${displayDay}. Código: 500.`
            : `Error al procesar el día ${displayDay}. Se continuará con el resto.`;
        setDayErrors((prev: any[]) => [...prev, { day: displayDay, message: msg }]);
      }

      setProgress({ current: i + 1, total });
    }

    setCurrentDayText(null);
    setDisabledBtn(false);
  };

  resolveTurns = async (data: any, setDisabledBtn: any, setSuccessResolveTurn: any) => {
    try {
      setDisabledBtn(true);
      const res = await this.repositoryManager.getTurnsRepository().resolveTurnsUncovereds(data);
      if (res) {
        setDisabledBtn(false);
        setSuccessResolveTurn(true);
        setTimeout(() => {
          setSuccessResolveTurn(false);
        }, 5000);
      }
    } catch (error) {
      setDisabledBtn(false);
      this.setError(error);
    }
  };

  setUpDate = (fechaIni: any, fechaEnd: any) => {
    const convertFechaIni = moment(fechaIni);
    const dateFormatIniMoment = moment.parseZone(convertFechaIni).utc().format();
    const formatDateIni = moment(dateFormatIniMoment).format('DD/MM/YYYY, HH:mm');

    const convertFechaFin = moment(fechaEnd);
    const dateFormatFinMoment = moment.parseZone(convertFechaFin).utc().format();
    const formatDateFin = moment(dateFormatFinMoment).format('DD/MM/YYYY, HH:mm');

    const dateStart = formatDateIni.split(',')[0];
    const timeStart = formatDateIni.split(',')[1];
    const timeEnd = formatDateFin.split(',')[1];

    return `${dateStart} ${timeStart.trim()} - ${timeEnd.trim()}`;
  };

  createBackup = async () => {
    try {
      const date = new Date();
      const timestamp = date.getTime();
      const res = await this.repositoryManager.getBackupsRepository().createBackup(timestamp);
      if (res) return true
    } catch (error){
      this.setError(error);
    }
  }

  createTurns = async (coverTurns: any) => {
    try {
      const res = await this.repositoryManager.getTurnsRepository().resolveTurnsUncovereds(coverTurns);
      if (res) return true
    } catch (error){
      this.setError(error);
    }
  }
}
